import { render, staticRenderFns } from "./DonationGroups.vue?vue&type=template&id=31386d38&"
import script from "./DonationGroups.vue?vue&type=script&lang=js&"
export * from "./DonationGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports